<template>
  <div>
    <p class="cm-mg-p-wzd">
      3.1 {{ $t('diseases.plague_or_disease_association') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }} *</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.business_ids', businesses)"
            clearable
            multiple
            v-bind:collapse-tags="true"
            class="select-primary custom-width-select shadow-sm required-business"
            v-model="model.business_ids"
            filterable
            p:placeholder=" $t('common_words.select_companies')"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none">{{
            $t('common_words.select_one_or_many_crops')
          }}</label>
          <br />
          <el-select
            @change="selectAllFromSelect('model.crop_ids', crops)"
            clearable
            multiple
            v-bind:collapse-tags="true"
            class="select-primary custom-width-select shadow-sm"
            v-model="model.crop_ids"
            filterable
            :placeholder="$t('common_words.select_one_or_many_crops')"
          >
            <el-option
              v-for="(option, index) in crops"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="index"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      model: {
        business_ids: [],
        crop_ids: [],
      },
      businesses: null,
      crops: null,
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
      this.crops = this.concatAll(this.crops.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {

          let others = [];
          this.businesses.forEach((item) => {
            this.model.business_ids.forEach((element) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          let othersC = [];
          this.crops.forEach((item) => {
            this.model.crop_ids.forEach((element) => {
              if (element == item.id) {
                othersC.push(item.name);
              }
            });
          });

          this.$emit('fillDiseaseForm', 'thirdStep', {
            business_names: others,
            crop_names: othersC,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return false;

          if (this.model.business_ids.length == 0) {
            return store.dispatch(
              'utils/validationInputsRequired',
              '-business'
            );
          } else return true;
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('businesses')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm')) {
            this.model.business_ids = this.selectElementsAsignFromModel(
              1,
              this.model.business_ids,
              this.businesses
            );

            if (
              this.model.business_ids === null &&
              this.businesses.length == 1
            ) {
              this.model.business_ids.push(this.businesses[0].id);
            }
          }

          Axios.getMasters('farms/crops')
            .then((response1) => {
              this.crops = this.concatAll(response1.data.data);

              if (!sessionStorage.getItem('editForm') && this.crops.length == 1)
                this.model.crop_ids.push(this.crops[0].id);

              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.business_ids = editForm.business_ids;
      this.model.crop_ids = editForm.crop_ids;
    }
  },
};
</script>
<style></style>
